import { useState, useRef } from "react";
import { Card, CardBody, CardText, Form, Col, Row, Spinner } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// componentes
import ModeloUpload from "../../../assets/statics/modelo_estoque_deletar.xlsx";
import ModalExcelRows from "../Voo/ModalExcelRows";
// utils e services
import readXlsxFile from "read-excel-file";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// validadores
import {
  allExcelColumnsDelete,
  findRowsWithError,
  getValidStocks,
  excelColumnsPtBrDelete,
} from "./ImportValidation";
// service
import { deleteStockActivity } from "../../../utils/services/schedulingAndStock";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ImportDeleteStock(props) {
  const { toggleModal, idEvent, refetch, jwt } = props;
  // arquivos selecionados e envio
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // erros e alertas
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  const [imgError, setImgError] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  // importando
  const importActivated = useRef(false);

  // adiciona os arquivos selecionados e reseta os contadores de envio
  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setSelectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  // cancela a importação e limpa o arquivo selecionado
  function cancelImport() {
    importActivated.current = false;
    setSelectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  // lê o excel, valida as linhas e deleta cada atividade de estoque encontrada
  async function uploadService() {
    importActivated.current = true;

    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      "ID do Estoque": {
        prop: "id",
        type: String,
      },
      Sala: {
        prop: "room",
        type: String,
      },
      Atividade: {
        prop: "task",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      try {
        setImgError("");

        const { rows } = await readXlsxFile(selectedFiles[0], { schema });
        const validateRows = rows.map((row, i) =>
          allExcelColumnsDelete(row, i),
        );

        setTotalRows(validateRows?.length);

        // validar colunas se esta no padrão
        const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
        const header = rowsWithoutSchema[0];
        const schemaCreate = Object.keys(schema);

        function isEqual(schema, header) {
          if (schema.length !== header.length) return false;

          return (
            schema.every((item) => header.includes(item)) &&
            header.every((item) => schema.includes(item))
          );
        }

        if (!isEqual(schemaCreate, header)) {
          setErrors([]);
          setModalErrors(true);
          return;
        }

        // validar campos vazios
        const rowsWithError = await findRowsWithError(validateRows);

        if (rowsWithError.length > 0 || rows.length === 0) {
          setErrors(rowsWithError);
          setModalErrors(true);
          return;
        }

        // validar se todos objetos estão cadastrados para poderem ser atualizados
        const validsStocks = await getValidStocks(validateRows, jwt, idEvent);

        if (validsStocks?.length > 0) {
          setErrors(validsStocks);
          setModalErrors(true);
          return;
        }

        for (const row of validateRows) {
          await deleteStockActivityFunc(row, validateRows.length);
        }
      } catch (error) {
        console.error("Error reading file:", error);
        setImgError("Erro ao ler o arquivo. Verifique o formato.");
      }
    };

    readXlsx();

    async function deleteStockActivityFunc(row, rowsCount) {
      await deleteStockActivity(row.id, jwt)
        .then((res) => {
          if (res.message === "DELETED") {
            count++;
            setTotalSended(count);
          }

          if (count === rowsCount || (count === 2 && rowsCount === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => {
          console.error("delete erro", error);
        });
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBrDelete}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            refetch();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"Os Estoques foram apagados com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_estoque_deletar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={f.name}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            className="mdi mdi-close text-danger"
                            style={{ fontSize: "16px", fontWeight: "700" }}
                            onClick={() => setSelectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            {imgError && <p className="text-danger">{imgError}</p>}
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              {btnCancel ? <Spinner size="sm" /> : "Deletar Estoques"}
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
